
import Card from "../../../assets/duotone/Card.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardIcon({ className, dataTestid = "CardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Card data-testid={dataTestid} className={classes} {...rest} />
  );
}
